export const smsTypes = [
  {
    value: 100,
    serviceId: 1,
    text: 'Lig Token',
    description:
      'Uma solução segura para entregas rápidas de senhas de uso único, autenticação e campanhas promocionais, incluindo casas de apostas. Tempo médio de entrega: 3 segundos.',
  },
  // {
  //   value: 200,
  //   serviceId: 5,
  //   text: 'Lig Shortcode',
  //   description:
  //     'O SMS Shortcode garante a máxima taxa de entrega, realizando até 15 tentativas. Tempo médio de entrega: 5 minutos.',
  // },
  {
    value: 300,
    serviceId: 6,
    text: 'Lig Massiva',
    description:
      'Similar ao Shortcode, porém realiza apenas uma tentativa de entrega. Tempo médio de entrega: 1 hora e 30 minutos.',
  },
  {
    value: 400,
    serviceId: 7,
    text: 'Lig Flash',
    description:
      'Exibe a mensagem diretamente na tela do celular, caso o dispositivo esteja desbloqueado. Se bloqueado, chega como SMS normal. Tempo médio de entrega: 5 minutos. (Obs: a operadora Vivo não garante a entrega).',
  },
  {
    value: 500,
    serviceId: 8,
    text: 'Lig Bet Promo',
    description: 'Destinado a campanhas de casas de apostas, realiza uma tentativa de entrega. Tempo médio de entrega: 1 hora e 30 minutos.',
  },
  {
    value: 700,
    serviceId: 10,
    text: 'Lig Bet Token 1',
    description:
      'Uma solução segura para entregas rápidas de senhas de uso único, autenticação e campanhas promocionais, incluindo casas de apostas. Tempo médio de entrega: 3 segundos.',
  },
  // {
  //   value: 800,
  //   serviceId: 26,
  //   text: 'Bet Token2',
  //   description:
  //     'Uma solução segura para entregas rápidas de senhas de uso único, autenticação e campanhas promocionais, incluindo casas de apostas. Tempo médio de entrega: 3 segundos.',
  // },
  // {
  //   value: 900,
  //   serviceId: 27,
  //   text: 'Bet Promo',
  //   description:
  //     'Uma solução segura para entregas rápidas de senhas de uso único, autenticação e campanhas promocionais, incluindo casas de apostas. Tempo médio de entrega: 3 segundos.',
  // },
  {
    value: 1000,
    serviceId: 28,
    text: 'Lig Premium',
    description:
      'Uma solução segura para entregas rápidas de senhas de uso único, autenticação e campanhas promocionais, incluindo casas de apostas. Tempo médio de entrega: 3 segundos.',
  },
  {
    value: 1100,
    serviceId: 30,
    text: 'Lig OTP',
    description:
      'Uma solução segura para entregas rápidas de senhas de uso único, autenticação e campanhas promocionais, incluindo casas de apostas. Tempo médio de entrega: 3 segundos.',
  },
  {
    value: 1200,
    serviceId: 31,
    text: 'Lig RCS',
    description:
      'Uma solução segura para entregas rápidas de senhas de uso único, autenticação e campanhas promocionais, incluindo casas de apostas. Tempo médio de entrega: 3 segundos.',
  },
  {
    value: 1300,
    serviceId: 32,
    text: 'Lig Fallback',
    description:
      'Uma solução segura para entregas rápidas de senhas de uso único, autenticação e campanhas promocionais, incluindo casas de apostas. Tempo médio de entrega: 3 segundos.',
  },
  {
    value: 1500,
    serviceId: 34,
    text: 'Lig WhatsApp Campaign',
    description:
      'Uma solução segura para entregas rápidas de senhas de uso único, autenticação e campanhas promocionais, incluindo casas de apostas. Tempo médio de entrega: 3 segundos.',
  },
]

export const campaignStatus = [
  { value: 1, label: 'Aguardando envio', color: 'secondary' },
  { value: 2, label: 'Em andamento', color: 'info' },
  { value: 3, label: 'Finalizada', color: 'success' },
  { value: 4, label: 'Cancelada', color: 'error' },
  { value: 5, label: 'Em fila', color: 'info' },
  { value: 6, label: 'Enviando', color: 'info' },
  { value: 7, label: 'Erro', color: 'error' },
  { value: 110, label: 'Mensagem enviada para a operadora', color: 'success' },
]

export const campaignOtimaStatus = [
  { value: 14, label: 'Aguardando envio', color: 'secondary' },
  { value: 1, label: 'Finalizada', color: 'success' },
  { value: 7, label: 'Cancelada', color: 'error' },
  { value: 11, label: 'Em fila', color: 'info' },
  { value: 12, label: 'Enviando', color: 'info' },
  { value: 2, label: 'Erro', color: 'error' },
]

export const isPausedStatus = [
  { value: false, label: 'Não' },
  { value: true, label: 'Sim' },
]

export const hasInteractionStatus = [
  { value: 0, label: 'Não' },
  { value: 1, label: 'Sim' },
]

export const serviceType = {
  SMSToken: 1,
  Voice30s: 2,
  Voice60s: 3,
  Sanitizer: 4,
  SMSShortcode: 5,
  SMSMassive: 6,
  SMSFlash: 7,
  SMSBet: 8,
  SMSBetToken1: 10,
  SMSOtp: 30,
  SMSRcs: 31,
  SMSFallback: 32,
  WhatsAppCampaign: 34,
}

export const voiceTypes = [
  { value: 1, text: 'Voz Simples' },
  { value: 2, text: 'Voz Interativa' },
]

export const voiceType = {
  Simple: 1,
  Intelligent: 2,
}

export const voiceServices = [
  { value: serviceType.Voice30s, text: 'Voz 30 segundos' },
  { value: serviceType.Voice60s, text: 'Voz 60 segundos' },
]

export const voiceDialSpeeds = [
  { value: 1, text: 'Lenta' },
  { value: 2, text: 'Normal' },
  { value: 3, text: 'Rápida' },
]

export const smsTemplate = {
  Pending: 1,
  Approved: 2,
  Refused: 3,
}

export const smsTemplateType = {
  Default: 1,
  Bet: 2,
}

export const smsTemplateStatus = [
  { value: smsTemplate.Pending, text: 'Aguardando Análise' },
  { value: smsTemplate.Approved, text: 'Aprovado' },
  { value: smsTemplate.Refused, text: 'Recusado' },
]

export const smsTemplateTypes = [
  { value: smsTemplateType.Default, text: 'Padrão' },
  { value: smsTemplateType.Bet, text: 'Bet' },
]

export const startCredit = {
  sent50: 'bonus-50-sms-gratis',
}

export const uraAction = {
  endCall: 1,
  playAudio: 2,
  sendSms: 3,
  playAudioSendSms: 4,
  fowardUra: 5,
  playAudioSendRequest: 6,
}

export const uraActions = [
  { id: uraAction.endCall, value: 'Desligar' },
  { id: uraAction.playAudio, value: 'Áudio + Desligar' },
  { id: uraAction.playAudioSendRequest, value: 'Áudio + Webhook' },
  { id: uraAction.playAudioSendSms, value: 'Áudio + SMS' },
  { id: uraAction.sendSms, value: 'SMS + Desligar' },
]

export const uraOptions = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]

export const userLevels = [
  { id: 1, text: 'Basic' },
  { id: 2, text: 'Starter' },
  { id: 4, text: 'Advanced' },
  { id: 6, text: 'Elite' },
]

export const isAffiliateItems = [
  { value: false, text: 'Não' },
  { value: true, text: 'Sim' },
]

export const uraSimpleSendSmsEnum = {
  No: 0,
  AllNumbers: 1,
  NumbersServed: 2,
}

export const uraSimpleSendSmsItems = [
  { value: uraSimpleSendSmsEnum.No, text: 'Não' },
  { value: uraSimpleSendSmsEnum.AllNumbers, text: 'Todos os números' },
  { value: uraSimpleSendSmsEnum.NumbersServed, text: 'Apenas números atendidos' },
]

export const uraSimpleSendSmsServiceItems = [
  { value: "OTIMA", text: 'OTP Voz' },
  // { value: "ELOMOBILE", text: 'Elo Mobile' },
]

export const typeAnswerEnum = {
  Digit: 1,
  Voice: 2,
}

export const typeAnswerOptions = [
  { value: typeAnswerEnum.Digit, text: 'Dígito' },
  { value: typeAnswerEnum.Voice, text: 'Reconhecimento de voz' },
]

export const userAuthMethod = {
  System: 'system',
  GoogleAuth: 'gauth',
}
